import { Base, base } from "./base"

export type Sizes = Base

export const sizes: Sizes = {
  ...base,
}
